import * as React from 'react';

const Sk2CoinsIcon = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='48px'
			height='48px'
			viewBox='0 0 48 48'
			xmlnsXlink='http://www.w3.org/1999/xlink'
		>
			<g>
				<path
					style={{
						opacity: 0.994
					}}
					fill='#062c39'
					d='M 0.5,-0.5 C 15.5,-0.5 30.5,-0.5 45.5,-0.5C 45.8333,0.5 46.5,1.16667 47.5,1.5C 47.5,16.1667 47.5,30.8333 47.5,45.5C 46.5,45.8333 45.8333,46.5 45.5,47.5C 30.8333,47.5 16.1667,47.5 1.5,47.5C 1.16667,46.5 0.5,45.8333 -0.5,45.5C -0.5,30.5 -0.5,15.5 -0.5,0.5C 0.166667,0.5 0.5,0.166667 0.5,-0.5 Z'
				/>
			</g>
			<g>
				<path
					style={{
						opacity: 1
					}}
					fill='#e0e2dc'
					d='M 10.5,5.5 C 12.1667,5.5 13.8333,5.5 15.5,5.5C 15.5,6.83333 15.5,8.16667 15.5,9.5C 17.5,9.5 19.5,9.5 21.5,9.5C 21.5,10.5 21.5,11.5 21.5,12.5C 18.8333,12.5 16.1667,12.5 13.5,12.5C 13.0074,14.8056 12.6741,17.139 12.5,19.5C 15.5,19.5 18.5,19.5 21.5,19.5C 21.5,20.8333 21.5,22.1667 21.5,23.5C 17.4862,23.6655 13.4862,23.4988 9.5,23C 7.25498,20.1041 6.92165,16.9374 8.5,13.5C 7.14682,12.4763 6.48015,11.143 6.5,9.5C 9.14205,9.51234 10.4754,8.17901 10.5,5.5 Z'
				/>
			</g>
			<g>
				<path
					style={{
						opacity: 1
					}}
					fill='#f04916'
					d='M 28.5,9.5 C 32.1667,9.5 35.8333,9.5 39.5,9.5C 38.9613,14.3214 37.7946,18.9881 36,23.5C 34.6487,21.981 33.1487,20.6477 31.5,19.5C 29.5,20.8333 27.5,22.1667 25.5,23.5C 25.5917,18.8274 26.5917,14.1607 28.5,9.5 Z'
				/>
			</g>
			<g>
				<path
					style={{
						opacity: 1
					}}
					fill='#e0e2db'
					d='M 11.5,27.5 C 18.8409,27.3337 26.1742,27.5003 33.5,28C 34.8045,28.804 35.4712,29.9707 35.5,31.5C 34.7026,34.8204 34.0359,38.1538 33.5,41.5C 31.8333,41.5 30.1667,41.5 28.5,41.5C 28.5758,38.0272 29.2424,34.6939 30.5,31.5C 28.5328,31.2606 26.6995,31.5939 25,32.5C 24.0467,35.4318 23.5467,38.4318 23.5,41.5C 21.396,41.7989 19.396,41.4656 17.5,40.5C 18.2728,37.5692 19.2728,34.7359 20.5,32C 18.5594,31.2571 16.7261,31.4238 15,32.5C 14.6676,35.5063 13.8343,38.3396 12.5,41C 10.7412,41.7975 9.0745,41.6309 7.5,40.5C 8.84338,36.1387 10.1767,31.8054 11.5,27.5 Z'
				/>
			</g>
		</svg>
	);
};

export default Sk2CoinsIcon;
